import styled from "styled-components";

export const HomeChartContainer = styled.div`
  width: 100%;
  background-color: #f7f7f7;
  /* @media only screen and (max-width: 768px) {
    .mobile {
      width: 50%;
    }
  } */
`;

export const HomeChartWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  @media only screen and (min-width: 768px) {
    flex-direction: row;
  }
`;

export const FirstChart = styled.div`
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  width: 100%;
  @media only screen and (max-width: 768px) {
    width: auto;
  }
`;

export const SecondChart = styled.div`
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  width: 100%;
  @media only screen and (max-width: 768px) {
    width: auto;
  }
`;

export const ChartContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ChartSpan = styled.span`
  font-family: GT Walsheim Pro;
  font-size: 18px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.02em;
  color: #09005b;
`;

export const ChartAmount = styled.div``;

export const ChartPrice = styled.span`
  font-family: Inter;
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0em;
  color: #0e0e0e;
`;

export const ChartData = styled.div`
  width: 100%;
  height: auto;
  margin-top: 30px;
  /* @media only screen and (max-width: 768px) {
    .mobile {
      width: 50%;
    }
  } */
`;
// export const StyledAreaChart = styled(AreaChart)`
//   width: 100%; /* Set width to 100% for mobile */
//    height: 246px;
//   @media only screen and (min-width: 768px) {
//     /* Apply styles for screens wider than 768px (typical tablets and desktops) */
//     /* You can adjust the min-width value as needed */
//     /* Example styles for larger screens */
//     width: 80%; /* Set width to 80% for desktop */
//     margin: 0 auto; /* Center align on larger screens */
//   }

//   /* Add any additional styles as needed */
// `;
